<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import MenuButton from './Components/Menu-Button.vue'
import DataView from './Components/Data-View.vue'
import ModalButtons from './Components/Modal-Menue.vue'
// local variables
const editDialog = ref(false)
const BLOCK_NAME = "html_block";

// define props
const props = defineProps({
    template_type: { type: String, required: true },
    index: { type: Number, required: false },
    data: { type: Object, required: true },
    workflow_id: { type: String, required: false },
    image_library: { type: Object, required: false }
})
// define emits
const emits = defineEmits(['blockCallback'])

// fields
const html_block = ref(props.data.html_block)
const template = ref(BLOCK_NAME)

// functions
const edit_block = () => {
    editDialog.value = true
}

const save_block = () => {
    emits('blockCallback',
        {
            "template_data": {
                "template": template.value,
                "html_block": html_block.value

            },
            "action": "save",
            "index": props.index
        }
    )
    editDialog.value = false
}

const delete_block = () => {
    emits('blockCallback',
        {
            "action": "delete",
            "index": props.index
        }
    )
    editDialog.value = false
}

const add_block = () => {

    const cb = {
        "template_data": {
            "template": template.value,
            "html_block": ""
        },
        "action": "add",
        "index": props.index
    }
    emits('blockCallback', cb)
}
const toggleDialog = () => {
    editDialog.value = false
}
</script>

<template>
    <!--------------------------------------------------->
    <!------------------ Menu View ---------------------->
    <!--------------------------------------------------->
    <MenuButton v-if="props.template_type == 'menu'" :add_block="add_block" button="pi-code" name="HTML" />

    <!--------------------------------------------------->
    <!------------------ Data View ---------------------->
    <!--------------------------------------------------->
    <DataView v-if="props.template_type == 'data'" :edit_block="edit_block" name="HTML Block">
        <Divider />
        <span v-html="html_block"></span>
    </DataView>
    <!--------------------------------------------------->
    <!------------------- Dialogs ----------------------->
    <!--------------------------------------------------->
    <Dialog v-model:visible="editDialog" :style="{ width: '80%' }" header="Block bearbeiten" :modal="true" class="p-fluid">
        <div class="">
            <ModalButtons :saveBlock="save_block" :deleteBlock="delete_block" :toggleDialog="toggleDialog" />
                    </div>
            <div>
            <div class="">
                <Textarea id="html_block" :autoResize="true" rows="12" v-model="html_block" style="background-color: #1e1e1e; color:#ffebcd" />
            </div>
        </div>
    </Dialog>
</template>